import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useIntl } from '@grandvisionhq/state';
import '../../../../../../context/actions.js';
import '../../../../../../context/reducer.js';
import { useProductData } from '../../../../../../context/product-context-hooks.js';
import '../../../../../../context/ProductContext.js';
import '../../../../../../context/CmsContext.js';
import '../../../../../../types/product.js';
import { isSunglasses, isFrames } from '../../../../../../types/typeguards.js';
import { FromPriceDisclaimers } from './FromPriceDisclaimers.js';

const FromPriceDisclaimersContainer = ()=>{
    const { getLabel  } = useIntl();
    const { product  } = useProductData();
    let props = {};
    const labelOptions = {
        hideLabelKey: true
    };
    if (isSunglasses(product)) {
        props = {
            includesLabel: getLabel('products.price.sunglasses.disclaimerIncludes', labelOptions),
            excludesLabel: getLabel('products.price.sunglasses.disclaimerExcludes', labelOptions),
            excludesTooltipLabel: getLabel('products.price.sunglasses.disclaimerExcludesTooltip', labelOptions)
        };
    }
    if (isFrames(product)) {
        props = {
            includesLabel: getLabel('products.price.frames.disclaimerIncludes', labelOptions),
            excludesLabel: getLabel('products.price.frames.disclaimerExcludes', labelOptions),
            excludesTooltipLabel: getLabel('products.price.frames.disclaimerExcludesTooltip', labelOptions)
        };
    }
    return /*#__PURE__*/ React.createElement(FromPriceDisclaimers, swcHelpers.extends({}, props));
};

export { FromPriceDisclaimersContainer };
//# sourceMappingURL=FromPriceDisclaimersContainer.js.map
